export default "__VITE_ASSET__59a92fb3__"